import { ShareScreenBase } from "./share-screen-base"
import { getDeeplinkUrl, isMobile, isUsOrCaTimezone } from "~/common/platform"
import { getMetaContent } from "~/common/get-meta-content"
import appPreviewImage from "~/images/landing/app-preview-image"
import { useDocumentTitleDescription } from "~/common/use-document-title"
import { AppText } from "~/ui/app-text"
import { useInviteFriendPhoneSubmission } from "~/hooks/use-phone-submission"
import { useCallback } from "react"
import { EVENT_IDS, SCREENS } from "~/common/analytics"
import { getInviterData } from "~/share/share-embedded-data"
import { useScreenTracking } from "~/hooks/use-screen-tracking"

export const InviteScreen = (): JSX.Element => {
  const appEnvironment = getMetaContent<string>("APP_ENVIRONMENT")
  const deeplinkUrl = getDeeplinkUrl(appEnvironment, "home")
  const { phoneValue, setPhoneValue, submitPhoneNumber } = useInviteFriendPhoneSubmission()
  useDocumentTitleDescription(
    "ChatBCC: You're invited to skip the waitlist",
    "Amazing people having real conversations about topics you love. Follow your favorites or start your own."
  )
  useScreenTracking(SCREENS.Share, {
    deeplink_url: deeplinkUrl,
  })

  const handleJoinRoom = useCallback(async () => {
    const successMessage =
      isMobile() || !isUsOrCaTimezone()
        ? "Download the app to join the group chat."
        : "Check your texts for a link to download the app."

    const successTitle = "You skipped the waitlist!"
    const inviterData = getInviterData()

    await submitPhoneNumber({
      successMessage,
      successTitle,
      trackingData: {
        unique_id: EVENT_IDS.SHARE_SCREEN_SKIP_WAITLIST,
        inviter_id: inviterData?.id,
        inviter_username: inviterData?.username,
        deeplink_url: deeplinkUrl,
      },
    })
  }, [deeplinkUrl, submitPhoneNumber])

  return (
    <ShareScreenBase
      deeplinkUrl={deeplinkUrl}
      className="justify-center"
      setPhoneValue={setPhoneValue}
      phoneValue={phoneValue}
      handleJoinRoom={handleJoinRoom}
      renderContent={() => (
        <div className="flex flex-col items-center justify-center md:my-[-24px]">
          <AppText
            variant="body2-medium"
            className="max-w-[400px] px-4 py-2 text-center text-base-white md:max-w-[600px] md:text-18"
          >
            Epic group chats hosted by your favorite podcasters, politicos, reality stars, athletes,
            comedians & more.
          </AppText>
          <img src={appPreviewImage.src} alt="App Preview" className="w-full md:max-w-[800px]" />
        </div>
      )}
    />
  )
}

export default InviteScreen
